export default class BluettiPayment {
  #paymentConfig = {
    gateways: {
      dev: 'https://dev-gw.poweroak.ltd:18443',
      test: 'https://test-gw.poweroak.ltd:18443',
      prod: 'https://gw.bluettipower.com'
    },
    apiModule: {
      attr: "MidpPayC",
      port: 20007
    },
    apiPath: {
      checkoutAbility: '/payment/v1/ability',
      createPay: '/payment/v1/create'
    }
  };
  #HEADER = {
    'x-os': 'web'
  };
  #paymentOptions = {
    paymentChannel: [],
    env: 'dev'
  };
  #channelId = '';
  #channelList = [];
  #offlineChannel = null;

  constructor(option = {}) {
    this.#paymentOptions = Object.assign({}, this.#paymentOptions, option);
    this.el = document.querySelector('.payment-container');
    this.#init();
  }
  async #init() {
    this.#renderLoading();
    this.#renderStyle();
    await this.#getCheckoutAbility();
  }
  #request(option) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      const headers = Object.assign({}, this.#HEADER, option.headers || {});
      const method = option.method || 'get';
      const data = method === 'post' ? option.data : null;
      xhr.open(method , option.url);
      this.#setHeaderParams(xhr, headers);
      xhr.send(data);
      xhr.onerror = (e) => {
        reject(e);
      }
      xhr.onload = (e) => {
        const res = JSON.parse(xhr.response)
        if (xhr.status === 200) {
          if (res.msgCode === 0) {
            resolve(res);
          }
          else {
            reject(res);
          }
        }
        else {
          reject(res);
        }
      }
    });
  }
  #mergeApi(apiPath) {
    const isBluettiApi = this.#isUseBluettiMergeApi() && this.#isUseBluettiGateway();
    return isBluettiApi ? $.api(this.#paymentConfig.apiModule, apiPath) : this.#paymentConfig.gateways[this.#paymentOptions.env] + '/api/midppayc' + apiPath;
  }
  #setHeaderParams(xhr, headers) {
    Object.keys(headers).map(item => {
      xhr.setRequestHeader(item, headers[item]);
    });
  }
  // 获取支付能力列表
  #getCheckoutAbility() {
    const apiPath = this.#paymentConfig.apiPath.checkoutAbility + '?appkey=' + this.#paymentOptions.appKey;
    const url = this.#mergeApi(apiPath);
    win.OkHttp.get(url)
    .then(res => {
      if (res.msgCode === 0) {
        this.#renderPaymentList(res.data);
      }
    })
    .catch(err => {
      console.log(err);
    })
  }
  // 获取当前选中的渠道信息
  getChannelId() {
    const targetInfo = this.#findChannelItem(this.#channelId);
    // 线下支付且需自动支付
    if (this.#channelId === 'offline' && targetInfo.autoPay) {
      return this.#offlineChannel;
    }
    return targetInfo;
  }
  // 设置渠道边框的状态
  setPaymentChannelActive(status, type) {
    const channel = document.querySelector('.payment-channel');
    if (channel) {
      channel.classList[type](status);
    }
  }
  // 创建交易
  pay(data) {
    this.#getLoading().then(() => {
      this.#createPay(data);
    });
  }
  #createPay(data) {
    const url = this.#mergeApi(this.#paymentConfig.apiPath.createPay);
    win.OkHttp.post(url, data)
      .then(res => {
        this.#payStatusHandle(res);
      })
      .catch(err => {
        this.#setLoadingStatus('close', 'add');
      })
  }
  #payStatusHandle(res) {
    this.#setLoadingStatus('close', 'add');
    if (res.msgCode === 0 && res.data) {
      this.#createDialog(res.data.payUrl);
    }
  }
  #createDialog(payUrl) {
    const iWidth = 800; //弹出窗口的宽度;
    const iHeight = 600; //弹出窗口的高度;
    const iTop = (window.screen.availHeight - 30 - iHeight) / 2; //获得窗口的垂直位置;
    const iLeft = (window.screen.availWidth - 10 - iWidth) / 2; //获得窗口的水平位置;
    const features = 'height=' + iHeight + ',width=' + iWidth + ',status=yes,top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,location=no';
    window.open(payUrl, "_blank", features);
  }
  #renderStyle() {
    const styleTag = document.createElement('style');
    styleTag.className = 'paymentStyle';
    const css = `
      .payment-container * {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
      }
      .payment-container ul { list-style: none; }
      .payment-channel {
        border-radius: 12px;
        border: 1px solid #EFF2F7;
      }
      .payment-channel__item {
        display: flex;
        align-items: center;
        min-height: 64px;
        border-bottom: 1px dashed #e5e5e5;
        padding: 12px 30px;
        cursor: pointer;
      }
      .payment-channel__item:last-child {
        border-bottom: none;
      }
      .payment-channel__item-checkbox {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: 20px;
        height: 20px;
        border: 1px solid #ebebeb;
        border-radius: 50%;
        transition: border-color .2s ease-in-out;
      }
      .payment-channel__item-checkbox:after {
        display: inline-block;
        content: '';
        width: 0;
        height: 0;
        border: 5px solid #ebebeb;
        border-radius: 50%;
        transition: border-color .2s ease-in-out;
      }
      .payment-channel__item-icon {
        width: 30px;
        height: 30px;
        margin: 0 20px;
        background: url('assets/citi.png') 0 0 no-repeat;
        background-size: cover;
      }
      .payment-channel__item-channel {
        font-size: 18px;
        color: #3D3D3D;
        text-align: left;
      }
      .payment-channel__item-content-l {
        display: flex;
        align-items: center;
      }
      .payment-channel__item-content-l .payment-channel__bank {
        display: flex;
        margin-left: 20px;
      }
      .payment-channel__bank .payment-channel__bank-icon {
        width: 64px;
        height: 40px;
        background-size: 100% 100%;
        border: 1px solid #e5e5e5;
        border-radius: 6px;
        margin-right: 10px;
      }
      .payment-channel__bank-icon:last-child {
        margin-right: 0;
      }
      .payment-channel__item-desc {
        font-size: 12px;
        color: #666666;
        margin-top: 8px;
      }
      .payment-channel.error {
        border-color: #F56C6C;
      }
      .payment-channel__item.is-active .payment-channel__item-checkbox,
      .payment-channel__item.is-active .payment-channel__item-checkbox:after,
      .payment-channel__offline.is-active .payment-channel__item-checkbox,
      .payment-channel__offline.is-active .payment-channel__item-checkbox:after {
        border-color: #0089ff;
      }
      .payment-container .payment-channel__offline {
        display: flex;
        align-items: center;
        margin-top: 8px;
        cursor: pointer;
      }
      .payment-container .payment-channel__offline-label {
        font-size: 12px;
        margin-left: 10px;
        color: #3D3D3D;
      }
      .payment-loading__container {
        position: fixed;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0,0,0,.3);
        z-index: 10000;
      }
      .payment-loading-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 80px;
        background-color: #fff;
        border-radius: 16px;
      }
      .payment-loading-content {
        position: relative;
        width: 40px;
        height: 40px;
        border: 2px solid #2997FF;
        border-top-color: rgba(255, 255, 255);
        border-right-color: rgba(255, 255, 255);
        border-bottom-color: rgba(255, 255, 255);
        border-radius: 100%;
        animation: circle infinite 0.75s linear;
        -webkit-animation: circle infinite 0.75s linear;
      }
      .payment-loading__container.close,
      .payment-container .payment-channel__offline.hide {
        display: none;
      }
      @keyframes circle {
        0% {
          transform: rotate(0);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      @-webkit-keyframes circle {
        0% {
          transform: rotate(0);
          -webkit-transform: rotate(0);
        }
        100% {
          transform: rotate(360deg);
          -webkit-transform: rotate(360deg);
        }
      }     
    `;
    styleTag.appendChild(document.createTextNode(css));
    if (!document.querySelector('.paymentStyle')) {
      document.head.appendChild(styleTag);
    }
  }
  #renderPaymentList(list) {
    let innerList = list;
    if (!innerList || Object.prototype.toString.call(innerList) !== '[object Array]') {
      innerList = [];
    }
    let listItem = '';
    const ulVO = document.createElement('ul');
    this.#channelList = [...this.#paymentOptions.paymentChannel, ...innerList];
    if (!this.#channelList || this.#channelList.length === 0) return
    this.#channelList.map(item => {
      let bankIconItem = '';
      if (item?.iconFiles) {
        item.iconFiles.map(item => {
          bankIconItem += `
            <div class="payment-channel__bank-icon" style="background-image: url(${item})"></div>
          `
        })
      }
      listItem += `<li class="payment-channel__item" data-id="${item.abilityId}">
        <div class="payment-channel__item-checkbox"></div>
        <div class="payment-channel__item-icon" style="background-image: url(${item.bigIcon})"></div>
        <div class="payment-channel__item-content">
          <div class="payment-channel__item-content-l">
            <p class="payment-channel__item-channel">${item.channelName}</p>
            ${ bankIconItem ? `<div class="payment-channel__bank">${bankIconItem}</div>` : ''} 
          </div>
          ${ item?.info ? `<p class="payment-channel__item-desc">${item.info}</p>` : '' }
        </div>
      </li>`;
    });
    const offlineItem = this.#renderAutoPayContent();
    ulVO.className = 'payment-channel';
    ulVO.innerHTML = listItem;
    this.el.innerHTML = '';
    this.el.appendChild(ulVO);
    if (offlineItem) {
      this.el.appendChild(offlineItem);
      this.#bindEventAutoPayEl();
    }
    this.#bindEvent();
  }
  #renderAutoPayContent() {
    const offlineItem = this.#findChannelItem('offline');
    if (offlineItem?.autoPay) {
      const warpVO = document.createElement('div');
      warpVO.className = offlineItem.autoPay.value ? 'payment-channel__offline is-active hide' : 'payment-channel__offline';
      warpVO.innerHTML = `
        <div class="payment-channel__item-checkbox"></div>
        <p class="payment-channel__offline-label">${offlineItem.autoPay.label}</p> 
      `;
      return warpVO;
    }
    return false;
  }
  #renderLoading() {
    const loadingContainer = document.createElement('div');
    loadingContainer.className = 'payment-loading__container close'
    loadingContainer.innerHTML =`
      <div class="payment-loading-wrap">
        <div class="payment-loading-content"></div>
      </div>
    `;
    if (this.#isExistLoadingDom()) return
    document.body.append(loadingContainer);
  }
  #bindEvent() {
    const that = this;
    if (this.#isExistJquery()) {
      $('.payment-channel').on('click', '.payment-channel__item', function() {
        const offlineEl = $('.payment-channel__offline');
        $(this).addClass('is-active');
        $(this).siblings().removeClass('is-active');
        that.#channelId = $(this).data('id');
        if (that.#channelId) {
          that.setPaymentChannelActive('error', 'remove');
        }
        if (that.#channelId === 'offline') {
          if (offlineEl.length > 0) offlineEl.removeClass('hide');
        }
        else {
          if (offlineEl.length > 0) offlineEl.addClass('hide');
        }
      });
      return
    }
    const paymentChannelVO = document.querySelectorAll('.payment-channel__item');
    const channelListVO = Array.prototype.slice.call(paymentChannelVO);
    function resetActiveStatus(list) {
      list.map(innerItem => innerItem.classList.remove('is-active'));
    }
    channelListVO.map(item => {
      item.addEventListener('click', function(e) {
        const offlineEl = document.querySelector('.payment-channel__offline');
        resetActiveStatus(channelListVO);
        this.classList.add('is-active');
        that.#channelId = this.getAttribute('data-id');
        if (that.#channelId) {
          that.setPaymentChannelActive('error', 'remove');
        }
        if (that.#channelId === 'offline') {
          if (offlineEl) offlineEl.classList.remove('hide');
        }
        else {
          if (offlineEl) offlineEl.classList.add('hide');
        }
      }, false);
    });
  }
  #bindEventAutoPayEl() {
    const offlineEl = document.querySelector('.payment-channel__offline');
    const that = this;
    this.#offlineChannel = this.#findChannelItem('offline');
    offlineEl.addEventListener('click', function() {
      const isActive = this.classList.contains('is-active');
      const method = isActive ? 'remove' : 'add';
      const val = method === 'add';
      this.classList[method]('is-active');
      that.#offlineChannel.autoPay.value = val;
    }, false);
  }
  #getLoading() {
    return new Promise((resolve, reject) => {
      this.#setLoadingStatus('close', 'remove');
      setTimeout(resolve, 300);
    });
  }
  #setLoadingStatus(status, type) {
    const loadingContainer = document.querySelector('.payment-loading__container');
    if (loadingContainer) {
      loadingContainer.classList[type](status);
    }
  }
  #findChannelItem(id) {
    const channelItemInfo = this.#channelList.find(item => item.abilityId === id) || {};
    return Object.assign({}, JSON.parse(JSON.stringify(channelItemInfo)));
  }
  #isUseBluettiGateway() {
    return !!(($ || jQuery) && ($.serverGatewayPry || jQuery.serverGatewayPry));
  }
  #isUseBluettiMergeApi() {
    return !!(($ || jQuery) && ($.api || jQuery.api));
  }
  #isExistJquery() {
    return !!($ || jQuery);
  }
  #isExistLoadingDom() {
    return !!(document.querySelector('.payment-loading__container'))
  }
}
